import React, {
  useState,
  useEffect,
  useContext,
  forwardRef,
  useRef,
  useImperativeHandle,
  lazy,
  Suspense,
} from 'react'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Grid from '@material-ui/core/Grid'
import LegacyImage from 'components/LegacyImage'
import StartSlide from 'steps/StartSlide'
import ArrowButton from 'images/inline/arrow-right.svg'
import SkipButton from 'steps/SkipButton'

import ServerError from 'steps/shared/ServerError'
import { getPersonalityData } from 'services/break.js'
import {
  start as serviceStart,
  complete as serviceComplete,
} from 'services/filtering'

import { userContext } from 'global/context/sub-contexts/userContext'
import { resizeContext } from 'global/context/sub-contexts/resize-context'
import analytics from 'global/AnalyticsData'

import './FilteringStep.scss'

const NewFilterStep = ({
  breakId,
  step,
  onGoToNext,
  onStepSkip,
  onStepStart,
  onStepComplete,
  isEmbed,
  scrollComplete,
  unlockNextStep,
  isComplete,
  onAuthRequired,
  onUnhandledError,
  HtmlFooter,
}) => {
  const FilteringModal = lazy(() => import('./FilteringModal'))

  let innerWidth = useContext(resizeContext).width
  // const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
  const [stepState, setStepState] = useState('NOT_STARTED')
  const [interacted, setInteracted] = useState(false)
  const [results, setFilterResult] = useState(step.filtering.results)
  const [isModalOpen, setModalState] = useState(false)
  const [selectedTile, setSelectedTile] = useState({})
  const [dropdownNum, setDropDown] = useState(null)
  const [pqResultId, setPqResultId] = useState()
  const savedResults = step.filtering.results
  const [activeFilters, setActiveFilters] = useState([])
  const [activeFilterValues, setActiveFilterValues] = useState([])
  const [activeSelect, setActiveSelect] = useState([])
  const [serverError, setServerError] = useState(false)
  const childRef = useRef()
  const sliderRef = useRef(null)
  const [waitingForServer, setWaitingForServer] = useState(false)
  const [stepSkipped, setStepSkipped] = useState(false)
  const [arrowDisabled, setArrowDisabled] = useState(true)
  const skipBtnEl = useRef(null)
  //   const nextArrowEl = useRef(null)

  const user_context = useContext(userContext)

  // console.log('filtering: ',innerWidth < 767)

  var sliderSettings = {
    dots: false,
    arrows: false,
    swipe: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    adaptiveHeight: true,
    slidesToScroll: 1,
  }

  const setArrowLocked = () => {
    // if (!nextArrowEl.current) return;
    // nextArrowEl.current.disabled = true;
    setArrowDisabled(true)
  }

  const setArrowUnlocked = () => {
    // if (!nextArrowEl.current) return;
    // nextArrowEl.current.disabled = false;
    setArrowDisabled(false)
  }

  const setSkipBtnVisibility = state => {
    //SkipButton component has its own ref called 'myRef'
    if (!skipBtnEl.current) return
    if (!skipBtnEl.current.myRef.current) return
    if (state === true) {
      skipBtnEl.current.myRef.current.style.display = 'block'
    } else {
      skipBtnEl.current.myRef.current.style.display = 'none'
    }
  }

  const handleSelect = (id, label, value, dropdown, text, skipAnalytics) => {
    pqResultId && setPqResultId(null)
    //TODO - refactor this
    //activeFilters is always 0 - because its an object, not an array
    if (activeFilters.length >= 1) {
      activeFilters[label] = []
      let postFilterResultSet = results.filter(result =>
        result.associatedItems.includes(value),
      )
      activeSelect[label].push(text)
      activeFilters[label].push(postFilterResultSet)
      // activeFilterValues = [value]
      setActiveFilters(activeFilters)
      // setActiveFilterValues(activeFilterValues)
      setActiveSelect(activeSelect)
      setFilterResult(postFilterResultSet) //clear filters before sort??
    } else {
      if (activeFilters[label]) {
        if (activeSelect[label][0] === text) {
          //deselect
          let updatedFilterValues = activeFilterValues
          updatedFilterValues[label] = []
          let newResults = savedResults
          Object.values(updatedFilterValues).forEach(arr => {
            if (arr.length > 0) {
              newResults = newResults.filter(result =>
                result.associatedItems.includes(arr[0]),
              )
            }
          })
          delete activeSelect[label]
          setActiveFilterValues(updatedFilterValues)
          setActiveFilters(activeSelect)
          setFilterResult(newResults)
        } else {
          //sorting an existing filter
          setActiveSelect([])
          setActiveFilters([])
          setFilterResult(savedResults) //clear filters before sort??
          activeFilters[label] = []
          activeSelect[label] = []
          let postFilterResultSet = savedResults.filter(result =>
            result.associatedItems.includes(value),
          )
          activeSelect[label].push(text)
          activeFilters[label].push(postFilterResultSet)

          //*** */
          let updatedFilterValues = activeFilterValues
          updatedFilterValues[label] = [value]
          setActiveFilterValues(updatedFilterValues)

          setActiveFilters(activeFilters)
          setActiveSelect(activeSelect)
          setFilterResult(postFilterResultSet) //clear filters before sort??
        }
      } else {
        //add index
        activeFilters[label] = []
        activeSelect[label] = []
        let postFilterResultSet = results.filter(result =>
          result.associatedItems.includes(value),
        )
        activeSelect[label].push(text)
        activeFilters[label].push(postFilterResultSet)

        //*** */
        let updatedFilterValues = activeFilterValues
        updatedFilterValues[label] = [value]
        setActiveFilterValues(updatedFilterValues)

        setActiveSelect(activeSelect)
        setActiveFilters(activeFilters)
        setFilterResult(postFilterResultSet) //clear filters before sort??
      }
    }
    setTimeout(() => {
      setDropDown(null)
      // @ts-ignore
      if (window) {
        //ie11 doesnt understand resize events so stackoverflow copypasta it is
        if (
          navigator.userAgent.indexOf('MSIE') !== -1 ||
          navigator.appVersion.indexOf('Trident/') > 0
        ) {
          var evt = document.createEvent('UIEvents')
          evt.initUIEvent('resize', true, false, window, 0)
          window.dispatchEvent(evt)
        } else {
          window.dispatchEvent(new Event('resize'))
        }
      }
      // window && window.dispatchEvent(new Event('resize'));
      childRef.current.GotoSlick(0)
    }, 200)

    if (!skipAnalytics) {
      window.dataLayer.push({
        event: 'step_interaction_filter_select_option_clicked',
      })

      analytics.stepEvent(
        'step_interaction_filter_select_option_clicked',
        step,
        {
          context_id: dropdown.id,
          context: dropdown.label,
          result_id: value,
          result: text,
        },
      )
    }
    // const filterResult = results.filter(result =>
    //     result.associatedItems.includes(value) )
    //     setFilterResult(filterResult)
  }
  const handleOpenTile = object => {
    setModalState(true)
    setSelectedTile(object)
    stepState !== 'COMPLETE' && setArrowUnlocked()

    window.dataLayer.push({
      event: 'step_interaction_filter_results_clicked',
    })

    analytics.stepEvent('step_interaction_filter_results_clicked', step, {
      result_id: object.id,
      result: object.title,
    })
  }

  const handleDropDown = (index, tag, dropdown) => {
    if (tag === 'select') {
      unlockNextStep(step.id)
      stepState !== 'COMPLETE' && setArrowUnlocked()
      setSkipBtnVisibility(false)

      if (dropdownNum === index) {
        setDropDown(null)
      } else {
        setDropDown(index)

        window.dataLayer.push({
          event: 'step_interaction_filter_select',
        })

        analytics.stepEvent('step_interaction_filter_select', step, {
          result_id: dropdown.id,
          result: dropdown.label,
        })
      }
    } else {
      if (dropdownNum !== null) {
        setDropDown(null)
      }
    }
  }

  const MobileFilter = (filtering, pqResultId) => {
    return (
      <>
        <div className="filtering__steps">
          {!!filtering.dropdowns.length &&
            filtering.dropdowns.map((dropdown, index) => {
              return (
                <select
                  className={`filtering__options mobile`}
                  onClick={e => {
                    e.stopPropagation()
                    e.preventDefault()
                    handleDropDown(index, 'select', dropdown)
                  }}
                  onChange={e => {
                    // console.log(e.target.value)
                    // console.log(e.target[e.target.selectedIndex].id)
                    const itemText = e.target.value
                    const itemId = e.target[e.target.selectedIndex].id
                    if (itemText === '') {
                      setActiveFilterValues([])
                      setActiveFilters([])
                      setActiveSelect([])
                      setFilterResult(savedResults)
                      pqResultId && setPqResultId(null)
                    } else {
                      handleSelect(
                        dropdown.id,
                        dropdown.label,
                        itemId,
                        dropdown,
                        itemText,
                      )
                    }
                  }}
                >
                  <option value="">
                    {/* {activeSelect[dropdown.label]
                        ? activeSelect[dropdown.label][0]
                          ? activeSelect[dropdown.label][0]
                          : dropdown.label
                        : dropdown.label} */}
                    {dropdown.label}
                  </option>
                  {dropdown.items &&
                    dropdown.items.map((item, optionindex) => {
                      //dynamic default filter based on pqresultid
                      const selectThis =
                        item.dynamics &&
                        item.dynamics.some(
                          dynamic => dynamic.value === pqResultId,
                        )
                      selectThis &&
                        handleSelect(
                          dropdown.id,
                          dropdown.label,
                          item.id,
                          dropdown,
                          item.text,
                        )

                      return (
                        <option
                          key={optionindex}
                          value={item.text}
                          id={item.id}
                        >
                          {item.text}
                        </option>
                      )
                    })}
                  <option value="" key="clear">
                    <span
                      className="clear"
                      // onClick={() => {
                      //   setActiveFilterValues([])
                      //   setActiveFilters([])
                      //   setActiveSelect([])
                      //   setFilterResult(savedResults)
                      //   pqResultId && setPqResultId(null)
                      // }}
                    >
                      Clear Filters
                    </span>
                  </option>
                </select>
              )
            })}
        </div>
      </>
    )
  }
  const DesktopFilter = (filtering, pqResultId) => {
    return (
      <>
        <div className="filtering__steps">
          {!!filtering.dropdowns.length &&
            filtering.dropdowns.map((dropdown, index) => {
              return (
                <div className={`filtering__step`} key={index}>
                  <a
                    title={
                      activeSelect[dropdown.label]
                        ? activeSelect[dropdown.label][0]
                          ? activeSelect[dropdown.label][0]
                          : dropdown.label
                        : dropdown.label
                    }
                    className={`filtering__step-name ${
                      index === dropdownNum ? 'active' : ''
                    }`}
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      handleDropDown(index, 'select', dropdown)
                    }}
                  >
                    {activeSelect[dropdown.label]
                      ? activeSelect[dropdown.label][0]
                        ? activeSelect[dropdown.label][0]
                        : dropdown.label
                      : dropdown.label}
                  </a>
                  <ul
                    className={`filtering__options`}
                    style={{
                      display: `${
                        index === dropdownNum ? 'inline-block' : 'none'
                      }`,
                    }}
                  >
                    {dropdown.items &&
                      dropdown.items.map((item, optionindex) => {
                        //dynamic default filter based on pqresultid
                        const selectThis =
                          item.dynamics &&
                          item.dynamics.some(
                            dynamic => dynamic.value === pqResultId,
                          )
                        selectThis &&
                          handleSelect(
                            dropdown.id,
                            dropdown.label,
                            item.id,
                            dropdown,
                            item.text,
                            true,
                          )
                        return (
                          <li key={optionindex}>
                            <label className="custom-btn-label">
                              <input
                                type="checkbox"
                                value="content 1"
                                name={item.text}
                                onChange={e => {
                                  handleSelect(
                                    dropdown.id,
                                    dropdown.label,
                                    item.id,
                                    dropdown,
                                    item.text,
                                  )
                                }}
                                checked={
                                  selectThis
                                    ? true
                                    : activeSelect[dropdown.label]
                                    ? activeSelect[dropdown.label][0] ===
                                      item.text
                                      ? true
                                      : false
                                    : false
                                }
                              />
                              <span className="filter-name">{item.text}</span>
                            </label>
                          </li>
                        )
                      })}
                    <li key="clear">
                      <span
                        className="clear"
                        onClick={() => {
                          setActiveFilterValues([])
                          setActiveFilters([])
                          setActiveSelect([])
                          setFilterResult(savedResults)
                          pqResultId && setPqResultId(null)
                          //BR-236 hack to allow slick to apply correct width for slider carousel
                          const slickList = document.querySelector(
                            `div[data-stepid='${step.id}'] .card__slider .slick-slider`,
                          )
                          slickList.style.visibility = 'hidden'
                          setTimeout(() => {
                            slickList.style.visibility = 'visible'
                            setDropDown(null)
                            // @ts-ignore
                            if (window) {
                              //ie11 doesnt understand resize events so stackoverflow copypasta it is
                              if (
                                navigator.userAgent.indexOf('MSIE') !== -1 ||
                                navigator.appVersion.indexOf('Trident/') > 0
                              ) {
                                var evt = document.createEvent('UIEvents')
                                evt.initUIEvent(
                                  'resize',
                                  true,
                                  false,
                                  window,
                                  0,
                                )
                                window.dispatchEvent(evt)
                              } else {
                                window.dispatchEvent(new Event('resize'))
                              }
                            }
                            // window && window.dispatchEvent(new Event('resize'));
                            childRef.current.GotoSlick(0)
                          }, 200)
                        }}
                      >
                        Clear Filters
                      </span>
                    </li>
                  </ul>
                </div>
              )
            })}
        </div>
      </>
    )
  }
  const handleNextClick = async () => {
    setWaitingForServer(true)
    console.log('Next Click')
    try {
      if (stepState === 'NOT_STARTED') {
        serviceStart(breakId, step.id)
          .then(async result => {
            if (onStepStart) {
              const { attempt, firstBreakEngagement } = result
              onStepStart(step, attempt, firstBreakEngagement)
            }
            await getPersonalityQuizResultId()
            setWaitingForServer(false)
            console.log('Filter Start')
            setStepState('STARTED')
            sliderRef.current.slickNext()
          })
          .catch(e => {
            console.log(e)
            setWaitingForServer(false)
            if (e.message === '401') {
              onAuthRequired && onAuthRequired()
            } else {
              onUnhandledError && onUnhandledError()
            }
            return false
          })
      }
      if (stepState === 'STARTED') {
        handleCompleteClick()
      }
    } catch (e) {
      setWaitingForServer(false)
      if (e.message === '401') {
        onAuthRequired && onAuthRequired()
      } else {
        onUnhandledError && onUnhandledError()
      }
    }
  }
  const handleCompleteClick = async () => {
    const response = await serviceComplete(breakId, step.id, false)
    setWaitingForServer(false)
    const { totalPoints } = response.detail
    user_context.setPoints(totalPoints)
    console.log('Filter Complete')
    !stepSkipped && onStepComplete && onStepComplete(step.id)
    onGoToNext && onGoToNext(step.id)
    setStepState('COMPLETE')
    // setArrowLocked()
  }
  const getPersonalityQuizResultId = async () => {
    try {
      const response = await getPersonalityData(breakId)
      const pqResultId = response.detail.resultId
      setPqResultId(pqResultId)
    } catch (e) {
      console.log(e)
      if (e.message === '401') {
        onAuthRequired && onAuthRequired()
      } else {
        onUnhandledError && onUnhandledError()
      }
    }
  }

  const handleStepSkip = async () => {
    const response = await serviceComplete(breakId, step.id, true)
    setWaitingForServer(false)
    onStepSkip && onStepSkip(step.id)
    setStepSkipped(true)
    setStepState('COMPLETE')
  }

  useEffect(() => {
    if (!step.hasStartScreen) {
      handleNextClick()
    }
  }, [])

  //listen for scrollComplete and fire off handleCompleteClick when toggled
  useEffect(() => {
    if (scrollComplete && !isComplete) {
      handleCompleteClick()
    }
  }, [scrollComplete, isComplete])

  let style = {}
  const bgImg =
    step && step.backgroundImage
      ? step.backgroundImage.id
      : step.backgroundImageId
  // const bgImg = null;
  if (step && step.backgroundColor) {
    style.backgroundColor = step.backgroundColor
  }
  if (bgImg) {
    style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${bgImg})`
  }
  const htmlFooterPadding = () => {
    let size = 0
    try {
      if (typeof window !== `undefined`) {
        size = document.querySelector('.break-html-footer').clientHeight
      }
    } catch {}
    return {
      paddingBottom: `${size}px`,
    }
  }
  return (
    <>
      <section
        className={`sponsored-flow-panel dumb-breakfooter-fix waiting-${waitingForServer}`}
        style={style}
      >
        <>
          <Slider
            ref={slider => (sliderRef.current = slider)}
            {...sliderSettings}
            className=""
          >
            {step.hasStartScreen && (
              <StartSlide
                headline={step.startHeader}
                para={step.startBody}
                footer={step.startFooter}
                backgroundImageId={step.startBackgroundImageId}
                backgroundColor={step.startBackgroundColor}
                onStartClicked={handleNextClick}
              />
            )}
            <div
              className="filtering"
              onClick={e => {
                handleDropDown(null, 'whole')
              }}
            >
              <div className="container">
                {bgImg && <span className="shade"></span>}
                <Grid container justify="center" spacing={2}>
                  <Grid item xs={12} md={12}>
                    <div className="filtering__content">
                      <h2
                        dangerouslySetInnerHTML={{
                          __html: step.filtering.headline,
                        }}
                      />
                      <p
                        dangerouslySetInnerHTML={{
                          __html: step.filtering.introCopy,
                        }}
                      />
                    </div>
                    {innerWidth < 767
                      ? MobileFilter(step.filtering, pqResultId)
                      : DesktopFilter(step.filtering, pqResultId)}
                    {/* {isMobile ? MobileFilter(step.filtering, pqResultId) : DesktopFilter(step.filtering, pqResultId)} */}
                    <div className="card__slider">
                      <SliderComponent className="card__slider" ref={childRef}>
                        {results &&
                          results.map((obj, index) => {
                            return (
                              <a
                                key={index}
                                onClick={e => {
                                  e.preventDefault()
                                  handleOpenTile(obj)
                                  !interacted && setInteracted(true)
                                }}
                                title={obj.title}
                                className="card__slide"
                              >
                                <figure
                                  // onClick={e => {
                                  //   handleOpenTile(obj)
                                  // }}
                                  className="card__slide-img"
                                >
                                  <LegacyImage image={obj.image} />
                                </figure>
                                <div className="card__slide-content">
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: obj.title,
                                    }}
                                  />
                                </div>
                              </a>
                            )
                          })}
                      </SliderComponent>
                    </div>
                  </Grid>
                </Grid>
                {stepState === 'STARTED' && step.showSkipButton && (
                  <SkipButton ref={skipBtnEl} onClick={handleStepSkip} />
                )}
              </div>
            </div>
          </Slider>
          <div className={`step1-button-container-hack`}>
            {stepState !== 'NOT_STARTED' && (
              <button
                //   ref={nextArrowEl}
                className={`quiz-button2 done`}
                onClick={handleNextClick}
                disabled={arrowDisabled}
                aria-label="Next"
              >
                <ArrowButton />
              </button>
            )}
            {HtmlFooter && <HtmlFooter />}
          </div>
        </>

        {serverError && <ServerError />}
      </section>
      {isModalOpen && (
        <Suspense fallback={<div>Loading...</div>}>
          <FilteringModal
            isModalOpen={isModalOpen}
            setModalState={setModalState}
            selectedTile={selectedTile}
            step={step}
          />
        </Suspense>
      )}
    </>
  )
}
export default NewFilterStep
const SliderComponent = forwardRef((props, ref) => {
  var sliderRef = {}
  var settings = {
    dots: true,
    arrows: true,
    infinite: false,
    speed: 500,
    variableWidth: true,
    dotsClass: 'slick-dots card__slider-dots',
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  }
  useImperativeHandle(ref, () => ({
    GotoSlick() {
      sliderRef.slickGoTo(0)
    },
  }))
  return (
    <Slider
      className={props.className}
      ref={slider => (sliderRef = slider)}
      {...settings}
    >
      {props.children.map((obj, index) => {
        return <React.Fragment key={index}>{obj}</React.Fragment>
      })}
    </Slider>
  )
})
